import React from 'react';
import { useIntl } from 'react-intl';

import { ButtonSecond } from '@/shared/components/Button';
import { useAppDispatch } from '@/shared/hooks/appRedux';
import { useCurrencyFormmater } from '@/shared/hooks/currencyFormmater';
import { PayPalLaterMessage } from '@/shared/services/paypal';

import { ProceedToCheckout } from '../../../index';
import {
  BoxBilling,
  NamePosition,
  PricePostion,
  RowBilling,
  Split,
  WrapperBilling,
  WrapperButtonBilling,
} from '../parts';

interface IProps {
  isShowPayPalMessage: boolean;
  itemTotal: Nullable<number>;
  handlingFee: Nullable<number>;
  tax: Nullable<number>;
  orderTotal: Nullable<number>;
  fulfillment: Nullable<number>;
  basketName: string;
  orderNumber: string;
}
interface IDataBiling {
  name: string;
  value: Nullable<number>;
  price: string;
}

const Billing: React.FC<IProps> = ({
  isShowPayPalMessage,
  itemTotal,
  tax,
  handlingFee,
  fulfillment,
  orderTotal,
  basketName,
  orderNumber,
}) => {
  const setFormatter = useCurrencyFormmater();
  const dispatch = useAppDispatch<CartAppDispatch>();
  const { formatMessage } = useIntl();
  const messages = {
    fulfillment: formatMessage({ id: 'Fulfillment' }),
    handlingFee: formatMessage({ id: 'HandlingFee' }),
    checkOut: formatMessage({ id: 'CheckOut' }),
    checkOutAriaLabel: formatMessage(
      { id: 'Checkout.Cart.Buttons.CheckOut.AriaLabel' },
      { 0: orderNumber },
    ),
    itemTotal: formatMessage({ id: 'ItemTotal' }),
    tax: formatMessage({ id: 'Tax' }),
    orderTotal: formatMessage({ id: 'OrderTotal' }),
  };
  const handleCheckoutClick = (): void => {
    dispatch(ProceedToCheckout(basketName));
  };

  const dataBilling: Array<IDataBiling> = [
    {
      name: messages.itemTotal,
      value: itemTotal,
      price: setFormatter(itemTotal),
    },
    {
      name: messages.handlingFee,
      value: handlingFee,
      price: setFormatter(handlingFee),
    },
    {
      name: messages.tax,
      value: tax,
      price: setFormatter(tax),
    },
    {
      name: messages.fulfillment,
      value: fulfillment,
      price: setFormatter(fulfillment),
    },
    {
      name: messages.orderTotal,
      value: orderTotal,
      price: setFormatter(orderTotal),
    },
  ];

  const getWidthPriceElement = (): number => {
    const maxWidth = 105;
    let maxPrice = 0;

    dataBilling.forEach((item) => {
      maxPrice = (
        item?.value && item.value > maxPrice ? item.value : maxPrice || item.value
      ) as number;
    });
    if (maxPrice > 99999) return maxWidth;
    if (maxPrice > 9999) return maxWidth - 10;
    if (maxPrice > 999) return maxWidth - 20;
    if (maxPrice > 99) return maxWidth - 28;
    if (maxPrice > 9) return maxWidth - 35;

    return maxWidth - 45;
  };

  const widthPriceElement = getWidthPriceElement();

  const billingList = dataBilling
    .filter((i) => !(i.name === messages.fulfillment && (i.value === 0 || i.value === null)))
    .filter((m) => !(m.name === messages.handlingFee && (m.value === 0 || m.value === null)))
    .map((item) => (
      <RowBilling className="RowBilling" key={item.name}>
        <NamePosition
          className="NamePosition"
          dangerouslySetInnerHTML={{
            __html: item.name,
          }}
        />
        <PricePostion className="PricePostion" width={widthPriceElement}>
          {item.price}
        </PricePostion>
      </RowBilling>
    ));

  return (
    <>
      <WrapperBilling className="WrapperBilling">
        <BoxBilling className="BoxBilling">{billingList}</BoxBilling>
      </WrapperBilling>
      <Split />
      <WrapperButtonBilling className="WrapperBilling">
        {isShowPayPalMessage && (
          <PayPalLaterMessage
            data-pp-message
            data-pp-layout="text"
            data-pp-placement="cart"
            data-pp-text-color="black"
            data-pp-logo-type="primary"
            data-pp-logo-position="left"
            data-pp-style-text-align="right"
            data-pp-style-text-size="14"
            data-pp-amount={orderTotal}
          />
        )}

        <ButtonSecond
          click={handleCheckoutClick}
          isDark
          className="ButtonCheckOut"
          aria-label={messages.checkOutAriaLabel}
          fontWeight="bold"
        >
          <span
            dangerouslySetInnerHTML={{
              __html: messages.checkOut,
            }}
          />
        </ButtonSecond>
      </WrapperButtonBilling>
    </>
  );
};

export default Billing;
